import templateMarkup from 'raw-loader!./logout-widget.html';
import BrandingService from '../../../services/branding.service';
import moment from 'moment-timezone';

class LogoutWidget {
    constructor(params) {
        var self = this;
        self.darkMode = document.body.classList.contains('dark');
        self.brandingService = BrandingService;
        self.currentYear = moment().year();
    }
}

export default { viewModel: LogoutWidget, template: templateMarkup };
